import React from 'react';
import { Link } from 'react-router-dom';

export function BlogPostCard({ title, excerpt, category, date, author, readTime, slug, imageUrl }) {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric' 
    });
  };

  return (
    <Link to={`/blog/${slug}`} className="block">
      <div className="rounded-lg border bg-card shadow-sm transition-all hover:shadow-md overflow-hidden">
        <div className="aspect-[8/6] w-full">
          <img
            src={imageUrl || "https://d22po4pjz3o32e.cloudfront.net/placeholder-image-landscape.svg"}
            alt={title}
            className="h-full w-full object-cover"
          />
        </div>
        <div className="p-6">
          <div className="flex flex-col space-y-4">
            <div className="text-sm text-muted-foreground">
              {category} • {formatDate(date)}
            </div>
            <h3 className="text-xl font-semibold">{title}</h3>
            <p className="text-gray-600">{excerpt}</p>
            <div className="flex items-center pt-2">
              <div className="text-sm">
                <span className="font-semibold">{author}</span>
                {readTime && (
                  <span className="text-muted-foreground"> • {readTime} min read</span>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
}